var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPenWhite = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.6 22.9",
    style: {
      enableBackground: "new 0 0 21.6 22.9"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#FFFFFF;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8570",
    x: 0.2,
    y: 9,
    transform: "matrix(0.678 -0.735 0.735 0.678 -5.0629 11.6125)",
    className: "st0",
    width: 21,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8571",
    x: 17.9,
    y: 0,
    transform: "matrix(0.678 -0.735 0.735 0.678 4.2054 14.7789)",
    className: "st0",
    width: 2.2,
    height: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9419",
    className: "st0",
    d: "M1.3,17.9l-1.3,5l5.1-1.4L1.3,17.9z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPenWhite);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyMS42IDIyLjkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDIxLjYgMjIuOTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNGRkZGRkY7fQo8L3N0eWxlPgo8ZyBpZD0iTGF5ZXJfMl8xXyI+Cgk8ZyBpZD0iTGF5ZXJfMS0yIj4KCQkKCQkJPHJlY3QgaWQ9IlJlY3RhbmdsZV84NTcwIiB4PSIwLjIiIHk9IjkiIHRyYW5zZm9ybT0ibWF0cml4KDAuNjc4IC0wLjczNSAwLjczNSAwLjY3OCAtNS4wNjI5IDExLjYxMjUpIiBjbGFzcz0ic3QwIiB3aWR0aD0iMjEiIGhlaWdodD0iNS4zIi8+CgkJCgkJCTxyZWN0IGlkPSJSZWN0YW5nbGVfODU3MSIgeD0iMTcuOSIgeT0iMCIgdHJhbnNmb3JtPSJtYXRyaXgoMC42NzggLTAuNzM1IDAuNzM1IDAuNjc4IDQuMjA1NCAxNC43Nzg5KSIgY2xhc3M9InN0MCIgd2lkdGg9IjIuMiIgaGVpZ2h0PSI1LjMiLz4KCQk8cGF0aCBpZD0iUGF0aF85NDE5IiBjbGFzcz0ic3QwIiBkPSJNMS4zLDE3LjlsLTEuMyw1bDUuMS0xLjRMMS4zLDE3Ljl6Ii8+Cgk8L2c+CjwvZz4KPC9zdmc+Cg==";